import "./flair/auto/forms.es6";
import "./settings.es6";

import "./page/_common.es6";
import "./page/pay/index.es6";
import "./page/pay/card.es6";
import "./page/apply.es6";
import "./page/app/va/index.es6";
import "./page/app/va/settings.es6";
import "./page/app/va/directory/map.es6";
import "./page/_component/global-navigation.es6";
import "./page/_component/venue-editor.es6";
import "./page/_component/account-panel-page.es6";

window.addEventListener("load", () => {
	// TODO: Add service worker back when ready. Must deal with log outs.

	// navigator.serviceWorker.register("/script/service-worker.js")
	// .then(registration => {
	// 	console.log("Service Worker is registered", registration);
	// })
	// .catch(err => {
	// 	console.error("Registration failed:", err);
	// });
});

window.addEventListener("beforeinstallprompt", (e) => {
	return;
	e.preventDefault();
	console.log("Ready to install...");
	let installEvent = e;

	let btn = document.createElement("button");
	btn.textContent = "Install App";
	btn.id = "pwa-install";
	document.body.append(btn);

	btn.addEventListener("click", e => {
		installEvent.prompt();
	})
});

// TODO: Check where this is used. Refactor to appropriate class, or remove if unused.
document.querySelectorAll(".access-list details").forEach(details => {
	details.addEventListener("click", e => {
		console.log(e, details.open);
		if(!details.open) {
			details.closest("assistant-card").scrollIntoView({
				behavior: "smooth"
			})
		}
	});
})

document.querySelectorAll("[data-nyi]").forEach(nyi => {
	nyi.addEventListener("click", e => {
		e.preventDefault();
		console.log(e);
		alert("Coming soon");
	})
})

document.querySelectorAll(".details-concertina-group details").forEach(details => {
	details.addEventListener("toggle", e => {
		if(!details.open) {
			return;
		}

		details.closest(".details-concertina-group").querySelectorAll("details").forEach(otherDetails => {
			if(otherDetails === details) {
				return;
			}

			otherDetails.open = false;

			let detailsOpenInput =
				details.closest("form")["detailsOpen"];
			if(detailsOpenInput) {
				detailsOpenInput.value = details.title;
			}

			details.scrollIntoView();
		});
	});
});
